import QueryString from 'query-string';
import { FetchService } from '.';

export default class DiscountService extends FetchService {
  constructor() {
    super();

    this.get = this.get.bind(this);
    this.post = this.post.bind(this);
    this.put = this.put.bind(this);
    this.delete = this.delete.bind(this);
  }

  get(query) {
    return this.Get('/discounts?' + QueryString.stringify(query), { cache: 'no-store' })
      .then((result) => {
        return Promise.resolve(result);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  post(venue_id, name, level, percent, min_qty, start_date, end_date, product_ids, membership_id = null, order_types = [1,2,3,4], applies_to = 'PRODUCTS', category_id = null) {
    return this.Post('/discounts', { body: JSON.stringify({ venue_id, name, level, percent, min_qty, start_date, end_date, product_ids, membership_id, order_types, applies_to, category_id }) })
      .then((result) => {
        return Promise.resolve(result);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  put(discount_id, name, level, percent, min_qty, start_date, end_date, product_ids, membership_id = null, order_types = [1,2,3,4], applies_to = 'PRODUCTS', category_id = null) {
    return this.Put('/discounts', { body: JSON.stringify({ discount_id, name, level, percent, min_qty, start_date, end_date, product_ids, membership_id, order_types, applies_to, category_id }) })
      .then((result) => {
        return Promise.resolve(result);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  delete(discount_id) {
    return this.Post('/discounts/delete', { body: JSON.stringify({ discount_id }) })
      .then((result) => {
        return Promise.resolve(result);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
}
